import { memo, useCallback } from 'react';

import { Flex, NumericOption, OptionGroup, SelectOption } from '@/components/core';
import { useOrganizationStore } from '@/store';

import { Section } from './Section';

const DATACENTER_LOCATIONS = [
  {
    id: 'eu',
    name: 'Europe / Ireland',
    value: 'eu',
    isDefault: true,
    isDisabled: false,
  },
];

const IPersonalData = () => {
  const update = useOrganizationStore((state) => state.update);
  const documentRetentionInDays = useOrganizationStore((state) => state.documentRetentionInDays);

  const onUpdateRetention = useCallback(
    (value: number) => {
      update({ documentRetentionInDays: value });
    },
    [update]
  );

  return (
    <Section
      title="Data retention"
      description="Control how long we retain your data so your agents keep improving while staying within policy."
    >
      <Flex col variant="plain" className={'gap-4 rounded-lg border border-gray-200 bg-white p-4'}>
        <OptionGroup className="gap-sm">
          <SelectOption
            label="Data center location"
            tooltip="Where your data is physically stored."
            items={DATACENTER_LOCATIONS}
            value={DATACENTER_LOCATIONS[0].id}
            className="items-center"
          />

          <NumericOption
            label="Document retention limit (days)"
            tooltip="Longer retention gives the agent more examples. Changing this value doesn't affect documents you've already uploaded."
            value={documentRetentionInDays}
            onChange={onUpdateRetention}
          />
        </OptionGroup>
      </Flex>
    </Section>
  );
};

export const PersonalData = memo(IPersonalData);
